/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1ExclusionAddressesFileMetaData } from '../models/V1ExclusionAddressesFileMetaData';
import { HttpFile } from '../http/http';

/**
* UploadExclusionAddressesRequest uploads a raw address CSV as a new org-owned exclusion file. Sent as multipart/form-data with the CSV in the \"file\" part; org_id travels as a query parameter. The CSV header must be exactly \"address1,address2,city,state,zip\".
*/
export class V1UploadExclusionAddressesRequest {
    'metadata'?: V1ExclusionAddressesFileMetaData;
    /**
    * The actual address CSV file. Header must be address1,address2,city,state,zip.
    */
    'chunk'?: string;
    /**
    * The org that will own the uploaded exclusion file
    */
    'orgId': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "V1ExclusionAddressesFileMetaData",
            "format": ""
        },
        {
            "name": "chunk",
            "baseName": "chunk",
            "type": "string",
            "format": "byte"
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1UploadExclusionAddressesRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

